import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Footer=()=> {
  return (
    <footer className="bg-dark-900 border-t border-white/5 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center mb-12">
          <div className="mb-6 md:mb-0 text-center md:text-left">
            <a href="#" className="text-2xl font-bold tracking-widest text-white uppercase">
              BL<span className="text-gold-500">.</span>Performance
            </a>
            <p className="text-gray-500 text-sm mt-2">Costruisci un corpo che funziona.</p>
          </div>
          <div className="flex space-x-6">
            <a href="#" className="text-gray-400 hover:text-gold-500 transition-colors">
              <SafeIcon icon={FiIcons.FiInstagram} className="w-6 h-6" />
            </a>
            <a href="mailto:bl.performancee@gmail.com" className="text-gray-400 hover:text-gold-500 transition-colors">
              <SafeIcon icon={FiIcons.FiMail} className="w-6 h-6" />
            </a>
          </div>
        </div>
        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-600">
          <p>&copy;{new Date().getFullYear()} BL.Performance. Tutti i diritti riservati.</p>
          <div className="flex space-x-4 mt-4 md:mt-0">
            <a href="#" className="hover:text-gray-400">Privacy Policy</a>
            <a href="#" className="hover:text-gray-400">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;